import { render, staticRenderFns } from "./LaudoAvaliacaoFundiarias.vue?vue&type=template&id=6b0e7944&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoFundiarias.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoFundiarias.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoFundiarias.vue?vue&type=style&index=0&id=6b0e7944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e7944",
  null
  
)

export default component.exports